// base component
import { PercentageDiffComponent } from './percentage-diff.component';

// components
export const PercentageDiffModule = angular.module('topbroker.shared.percentageDiff', [])
  .component('percentageDiff', PercentageDiffComponent)
  .name;

export default PercentageDiffModule;
